import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addBestsellersOnGridPagesSelector = createSelector(testTargetOffersSelector, offers => offers.addBestsellersOnGridPages || Empty.Object);

export { addBestsellersOnGridPagesSelector };
